/** 标记本机刚提交的订单写操作，避免 Socket 回流时再走「他人已更新」观察者逻辑 */

const LOCAL_MUTATION_MS = 12000;
/** @type {{ orderId: string | null, until: number }} */
let localMutation = { orderId: null, until: 0 };

export const markLocalOrderMutation = (orderId) => {
	if (orderId == null || orderId === '') return;
	localMutation = {
		orderId: String(orderId),
		until: Date.now() + LOCAL_MUTATION_MS,
	};
};

export const isRecentLocalOrderMutation = (orderId) => {
	if (orderId == null || orderId === '') return false;
	if (localMutation.orderId !== String(orderId)) return false;
	return Date.now() < localMutation.until;
};
